<template>
  <div>
    <slot />
    <div class="supply-category-area">
      <tree-transfer
        pid="parentId"
        :defaultTransfer="true"
        :defaultCheckedKeys="selectedKeys"
        :title="[`${moduleType}品类`, `已选择品类`]"
        :from_data="treeList"
        :defaultProps="{ label: 'name' }"
        @addBtn="handleAdd"
        @removeBtn="handleRemove"
        mode="transfer"
        height="540px"
        :filter="true"
        @right-check-change="handleChange"
        :button_text="['添加', '移除']"
      />
    </div>
  </div>
</template>
<script>
import TreeTransfer from 'el-tree-transfer';
import clone from 'lodash/cloneDeep';

export default {
  name: 'Category-select',
  props: {
    moduleType: {
      type: String,
      validator: val => ['采购', '供应'].indexOf(val) !== -1,
      default: '供应',
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedKeys: [],
      treeList: [],
    };
  },
  methods: {
    disableTree(tree) {
      tree.forEach(item => {
        this.$set(item, 'disabled', true)
        if (item.children) {
          this.disableTree(item.children)
        }
      });
    },
    handleChange(_, checkedInfo, isCheckAll) {
      // console.log('checked', checkedInfo);
      // console.log('checked--parentKeys', parentKeys);
      // this.selectedKeys = checkedKeys;
      // this.$emit('onChange', checkedKeys);
      // this.selectedKeys = checkedNodes;
      // this.$emit('onChange', checkedNodes);
    },
    updateTreeData(value) {

      this.treeList = value;

      if (this.disabled) {
        this.disableTree(this.treeList);
      }
    },
    handleAdd(fromData, toData, obj) {
      this.$emit('onChange', toData.filter(
        item => item || item === 0
      ));
    },
    // NOTE:不要奇怪为什么这里的单词叫harf上面是half，这是组件就是这样的，作者单词拼写错误吧，哈哈哈
    handleRemove(_, data, all) {
      // this.selectedKeys = [];
      // console.log(data);
      // this.$emit('onChange', []);
      // console.log('removed', keys);
      // console.log('removed--parentKeys', harfKeys);
      this.$emit('onChange', data);
    },
  },
  mounted() {
    this.updateTreeData(clone(this.treeData));
    this.selectedKeys = this.defaultCheckedKeys;
  },
  watch: {
    defaultCheckedKeys(value) {
      this.selectedKeys = clone(value);
    },
    treeData(value) {
      this.updateTreeData(clone(value));
    },
    disabled() {
      this.updateTreeData(this.treeList);
    }
  },
  components: { TreeTransfer },
};

</script>
<style lang="scss" scoped>
@import url('./style.scss');
</style>